/* ------------------------------------*\
	VARIABLE DECLARATION
\*------------------------------------*/
project = {
	setupExample: function () {
	},

	setupPage: function () {
		if (utils.enableDebug) {
			console.log(
				'<!-- ----------------------------------------------------- -->\n' +
				'<!-- Single Project Page -->\n' +
				'<!-- ----------------------------------------------------- -->');
		}

		if (!utils.isMobile() && !utils.isSmallScreen()) {
			// project.setupExample();
		}
	},
};
